<template>
    <templateLogin>
        <div class="header">
        </div>
        <div class="body">
            <div class="box-login">
                <div>
                    <div class="page-message">
                        <div class="icon" :class="type">
                            <i :class="icon"></i>
                        </div>
                        <h1>{{texts.title}}</h1>
                        <div v-html="texts.text" class="mb-20"></div>
                        <div class="control" v-if="btnText">
                            <router-link :to="btnUrl">{{btnText}}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </templateLogin>
</template>

<script>
    import templateLogin from '@/templates/page-login'

    export default {
        components: { templateLogin},
        data() {
            return {
                icon: '',
                type: '',
                url: '',
                btnUrl: '',
                btnText: '',
                texts: {
                    title: '',
                    text: '',
                }
            }
        },
        methods: {
            checkMessageExist(){
                if (this.texts.title == '') this.$router.push({ path: '/login'})
            }
        },
        created(){

           this.texts.title = this.$route.params.title ? this.$route.params.title : ''
           this.texts.text  = this.$route.params.text
           this.icon        = this.$route.params.icon
           this.type        = this.$route.params.type
           this.btnUrl      = this.$route.params.btnUrl ? this.$route.params.btnUrl : ''
           this.btnText     = this.$route.params.btnText
           this.checkMessageExist()
        }

    };
</script>
